function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26 28.944c-10.675 7.59-23.419 3.639-21.722-7.556C4.766 18.168.5 11 .5 11c8.696-.24 23.8 2.833 25.69 14.166"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 29.889C22.223 33.666 24.112 45 17.5 45c-5.686 0-7.182-4.956-6.61-8.5.903-5.61 4.721-9.445 15.11-9.067"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 20.5a2 4.5 0 11-4 0 2 4.5 0 114 0z",
  transform: "matrix(.94446 0 0 .5247 .5 8.27)",
  strokeWidth: 1.421
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.778 29.165c0 4.294-1.889 10.168-1.889 10.168S26 33.46 26 29.165c0-4.295.846-7.777 1.89-7.777 1.043 0 1.888 3.482 1.888 7.777z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.684 28.944c10.675 7.59 23.42 3.639 21.723-7.556C50.919 18.168 55.184 11 55.184 11c-8.696-.24-23.8 2.833-25.689 14.166"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.684 29.889C33.462 33.666 31.573 45 38.184 45c5.687 0 7.182-4.956 6.611-8.5-.903-5.61-4.722-9.445-15.111-9.067M25.056 8.166s-3.588-2.32-4.722 0c-1.135 2.32 6.611 8.5 6.611 8.5M30.61 8.166s3.587-2.32 4.722 0c1.134 2.32-6.611 8.5-6.611 8.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 19a2 2 0 11-4 0 2 2 0 114 0z",
  transform: "matrix(1.94446 0 0 1.77287 -9.334 -16.028)",
  strokeWidth: 0.539
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.111 38.889a1.889 1.889 0 103.778 0 1.889 1.889 0 10-3.778 0z",
  strokeWidth: 1.0001831399999999
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.94446 0 0 1.77287 26.066 -16.028)",
  d: "M12 19a2 2 0 11-4 0 2 2 0 114 0z",
  strokeWidth: 0.539
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.111 38.889a1.889 1.889 0 103.778 0 1.889 1.889 0 10-3.778 0z",
  strokeWidth: 1.0001831399999999
}));

var SvgButterfly = function SvgButterfly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButterfly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Butterfly.0d31ad7f.svg";
export { ForwardRef as ReactComponent };